import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-details-plams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-details-plams.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { AppControllerService } from "../../../../app-controller.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import RecipientUtils from "../../../../shared/utils/recipient-utils";
import { PropertyAndLeaseService } from "../../../../shared/services/modules/property-and-lease.service";
import { ViewApplicationBaseComponent } from "../../../shared/view-application-base/view-application-base.component";
import { ViewApplicationDetailsPlamsConstants } from "./view-application-details-plams.constants";
import { ApplicationViewService } from "../../../shared/application-view.service";
import { RouterParamsService } from "../../../../shared/services/route-params.service";
import { DatePipe } from "@angular/common";
let ViewApplicationDetailsPlamsComponent = class ViewApplicationDetailsPlamsComponent extends ViewApplicationBaseComponent {
    applicationViewService;
    datePipe;
    aflaModuleStrategyService;
    selectedApplicationService;
    appControllerService;
    changeDetectorRef;
    propertyAndLeaseService;
    saShortDatePipe;
    routerParamsService;
    detailsForm;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    descriptionLabel = ViewApplicationDetailsPlamsConstants.DESCRIPTION_LABEL;
    applicationTypeLabel = ViewApplicationDetailsPlamsConstants.APPLICATION_TYPE_LABEL;
    leaseLabel = ViewApplicationDetailsPlamsConstants.LEASE_LABEL;
    drawPolyonLabel = ViewApplicationDetailsPlamsConstants.DRAW_POLYGON_LABEL;
    polygonDrawnLabel = ViewApplicationDetailsPlamsConstants.POLYGON_DRAWN_LABEL;
    leaseTypeLabel = ViewApplicationDetailsPlamsConstants.LEASE_TYPE_LABEL;
    leaseReasonTypeLabel = ViewApplicationDetailsPlamsConstants.LEASE_REASON_LABEL;
    leaseUseLabel = ViewApplicationDetailsPlamsConstants.LEASE_USE_LABEL;
    leaseRentalAgreementLabel = ViewApplicationDetailsPlamsConstants.LEASE_RENTAL_AGREEMENT_LABEL;
    leaseStartDateLabel = ViewApplicationDetailsPlamsConstants.LEASE_START_DATE_LABEL;
    leaseEndDateLabel = ViewApplicationDetailsPlamsConstants.LEASE_END_DATE_FORM_LABEL;
    leaseContractNumberLabel = ViewApplicationDetailsPlamsConstants.LEASE_CONTRACT_NUMBER_LabeL;
    leaseAccountNumberLabel = ViewApplicationDetailsPlamsConstants.LEASE_ACCOUNT_NUMBER_LabeL;
    leaseContractEscalationLabel = ViewApplicationDetailsPlamsConstants.LEASE_CONTRACT_ESCALLATION_LabeL;
    leasePeriodLabel = ViewApplicationDetailsPlamsConstants.LEASE_PERIOD_LabeL;
    leaseNoticePeriodLabel = ViewApplicationDetailsPlamsConstants.LEASE_NOTICE_PERIOD_DATE_LabeL;
    lesseeTypeTypeLabel = ViewApplicationDetailsPlamsConstants.LESSEE_TYPE_LABEL;
    lesseeLabel = ViewApplicationDetailsPlamsConstants.LESSEE_LABEL;
    alienationLabel = ViewApplicationDetailsPlamsConstants.ALIENATION_LABEL;
    saleAmountLabel = ViewApplicationDetailsPlamsConstants.SALE_AMOUNT_LABEL;
    dateofDeedTransferLabel = ViewApplicationDetailsPlamsConstants.DATE_OF_DEED_TRANSFER_LABEL;
    evaluationAmountLabel = ViewApplicationDetailsPlamsConstants.EVALUATION_AMOUNT_LABEL;
    acquisitionLabel = ViewApplicationDetailsPlamsConstants.ACQUISITION_LABEL;
    buyerLabel = ViewApplicationDetailsPlamsConstants.BUYER_LABEL;
    sellerLabel = ViewApplicationDetailsPlamsConstants.SELLER_LABEL;
    referenceNumberLabel = ViewApplicationDetailsPlamsConstants.REFERENCE_NUMBER_LABEL;
    descriptionFormControlName = ViewApplicationDetailsPlamsConstants.DESCRIPTION_FORM_CONTROL_NAME;
    applicationTypeFormControlName = ViewApplicationDetailsPlamsConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    leaseTypeFormControlName = ViewApplicationDetailsPlamsConstants.LEASE_TYPE_FORM_CONTROL_NAME;
    leaseReasonFormControlName = ViewApplicationDetailsPlamsConstants.LEASE_REASON_FORM_CONTROL_NAME;
    leaseUseFormControlName = ViewApplicationDetailsPlamsConstants.LEASE_USE_FORM_CONTROL_NAME;
    leaseRentalAgreementFormControlName = ViewApplicationDetailsPlamsConstants.LEASE_RENTAL_AGREEMENT_FORM_CONTROL_NAME;
    leaseStartDateFormControlName = ViewApplicationDetailsPlamsConstants.LEASE_START_DATE_FORM_CONTROL_NAME;
    leaseEndDateFormControlName = ViewApplicationDetailsPlamsConstants.LEASE_END_DATE_FORM_CONTROL_NAME;
    leaseContractNumberFormControlName = ViewApplicationDetailsPlamsConstants.LEASE_CONTRACT_NUMBER_FORM_CONTROL_NAME;
    leaseAccountNumberFormControlName = ViewApplicationDetailsPlamsConstants.LEASE_ACCOUNT_NUMBER_FORM_CONTROL_NAME;
    leaseContractEscalationFormControlName = ViewApplicationDetailsPlamsConstants.LEASE_CONTRACT_ESCALATION_FORM_CONTROL_NAME;
    leasePeriodFormControlName = ViewApplicationDetailsPlamsConstants.LEASE_PERIOD_FORM_CONTROL_NAME;
    leaseNoticePeriodFormControlName = ViewApplicationDetailsPlamsConstants.LEASE_NOTICE_PERIOD_DATE_FORM_CONTROL_NAME;
    lesseeTypeFormControlName = ViewApplicationDetailsPlamsConstants.LESSEE_TYPE_FORM_CONTROL_NAME;
    lesseeFormControlName = ViewApplicationDetailsPlamsConstants.LESSEE_FORM_CONTROL_NAME;
    saleAmountAlienationFormControlName = ViewApplicationDetailsPlamsConstants.SALE_AMOUNT_ALIENATION_FORM_CONTROL_NAME;
    dateofDeedAlienationTransferFormControlName = ViewApplicationDetailsPlamsConstants.DATE_OF_DEED_TRANSFER_ALIENATION_FORM_CONTROL_NAME;
    evaluationAmountAlienationFormControlName = ViewApplicationDetailsPlamsConstants.EVALUATION_AMOUNT_ALIENATION_FORM_CONTROL_NAME;
    buyerFormControlName = ViewApplicationDetailsPlamsConstants.BUYER_FORM_CONTROL_NAME;
    saleAmountFormControlName = ViewApplicationDetailsPlamsConstants.SALE_AMOUNT_FORM_CONTROL_NAME;
    dateofDeedTransferFormControlName = ViewApplicationDetailsPlamsConstants.DATE_OF_DEED_TRANSFER_FORM_CONTROL_NAME;
    evaluationAmountFormControlName = ViewApplicationDetailsPlamsConstants.EVALUATION_AMOUNT_FORM_CONTROL_NAME;
    sellerFormControlName = ViewApplicationDetailsPlamsConstants.SELLER_FORM_CONTROL_NAME;
    referenceNumberControlName = ViewApplicationDetailsPlamsConstants.REFERENCE_NUMBER_FORM_CONTROL_NAME;
    leaseAreaDrawn = false;
    applicationTypes = [];
    leaseTypes = [];
    lesseeTypes = [];
    lesseeDisableFilterBy = true;
    lesseeDisableAdd = true;
    lesseeDisableDelete = true;
    lesseeDisableEditing = true;
    lesseeShowGroupsDropdown = true;
    lesseeGroups = [];
    lesseeListLabel = "Lessee";
    buyerDisableFilterBy = true;
    buyerDisableAdd = true;
    buyerDisableDelete = true;
    buyerDisableEditing = true;
    buyerShowGroupsDropdown = true;
    buyerGroups = [];
    buyerListLabel = "Buyer";
    sellerDisableFilterBy = true;
    sellerDisableAdd = true;
    sellerDisableDelete = true;
    sellerDisableEditing = true;
    sellerShowGroupsDropdown = true;
    sellerGroups = [];
    sellerListLabel = "Seller";
    fullApplicationCheckRequired = false;
    requiredClass = SharedConstants.CLASS_REQUIRED_TEXT;
    requiredText = SharedConstants.REQUIRED_TEXT_INDICATOR;
    descriptionPlaceholder = "Enter description";
    inputID = SharedConstants.CLASS_DESCRIPTION_TEXT;
    applicationType = null;
    jobId = null;
    selectedApplicationSubscription;
    getLookupsObservableSubscription;
    getLesseesObservableSubscription;
    getSellersObservableSubscription;
    propertyAndLeaseServiceSubscription;
    constructor(applicationViewService, datePipe, aflaModuleStrategyService, selectedApplicationService, appControllerService, changeDetectorRef, propertyAndLeaseService, saShortDatePipe, routerParamsService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationViewService = applicationViewService;
        this.datePipe = datePipe;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appControllerService = appControllerService;
        this.changeDetectorRef = changeDetectorRef;
        this.propertyAndLeaseService = propertyAndLeaseService;
        this.saShortDatePipe = saShortDatePipe;
        this.routerParamsService = routerParamsService;
        this.getMetadata();
        this.initForm();
    }
    ngOnInit() {
        this.getLookups();
        this.listenForRouteParamChange();
    }
    loadMetadata(stepMeta) {
        this.lesseeGroups = stepMeta.lesseeGroup;
        this.buyerGroups = stepMeta.buyerGroup;
        this.sellerGroups = stepMeta.sellerGroup;
    }
    handleRouteChange() {
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("detailsForm");
        this.detailsForm = form;
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.appControllerService.selectedModuleID} and (name eq 'ApplicationType' or name eq 'LeaseType' or name eq 'LesseeType')`,
        };
        this.getLookupsObservableSubscription = this.applicationViewService.getLookupsObservable(params).subscribe({
            next: (response) => {
                this.onGetLookupsCompleted(response);
            }, error: (error) => {
                this.appControllerService.handleServerErrorMessage(ViewApplicationDetailsPlamsConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        this.applicationTypes = [];
        this.leaseTypes = [];
        this.lesseeTypes = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "ApplicationType") {
                    this.applicationTypes.push(JSON.parse(item.content));
                }
                if (item.name === "LeaseType") {
                    this.leaseTypes.push(JSON.parse(item.content));
                }
                if (item.name === "LesseeType") {
                    this.lesseeTypes.push(JSON.parse(item.content));
                }
            });
            this.changeDetectorRef.markForCheck();
            this.subscribeToSelectedApplication();
        }
    }
    subscribeToSelectedApplication() {
        this.selectedApplicationSubscription = this.selectedApplicationService.$selectedApplication.subscribe((application) => {
            if (application) {
                this.setApplicationDetails(application);
            }
        });
    }
    setApplicationDetails(application) {
        this.jobId = application.jobId;
        this.leaseAreaDrawn = false;
        // checks the application has application details set
        this.applicationType = application.applicationType;
        this.applicationTypes.forEach(item => {
            if (item.value === application.applicationType) {
                this.detailsForm.get(this.applicationTypeFormControlName).setValue(item);
            }
        });
        this.detailsForm.get(this.applicationTypeFormControlName).disable();
        this.detailsForm.get(this.descriptionFormControlName).setValue(application.description);
        this.detailsForm.get(this.descriptionFormControlName).disable();
        this.detailsForm.get(this.referenceNumberControlName).setValue(application.referenceNumber);
        this.detailsForm.get(this.referenceNumberControlName).disable();
        if (this.applicationType === "Alienation") {
            this.detailsForm.get(this.saleAmountAlienationFormControlName).setValue(application.saleAmount);
            this.detailsForm.get(this.saleAmountAlienationFormControlName).disable();
            this.detailsForm.get(this.evaluationAmountAlienationFormControlName).setValue(application.evaluationAmount);
            this.detailsForm.get(this.evaluationAmountAlienationFormControlName).disable();
            this.detailsForm.get(this.dateofDeedAlienationTransferFormControlName).setValue(this.saShortDatePipe.transform(application.dateOfDeedTransfer, "yyyy-MM-dd"));
            this.detailsForm.get(this.dateofDeedAlienationTransferFormControlName).disable();
            this.getBuyers(application.jobId);
        }
        if (this.applicationType === "Lease") {
            this.leaseTypes.forEach(item => {
                if (item.value === application.leaseType) {
                    this.detailsForm.get(this.leaseTypeFormControlName).setValue(item);
                }
            });
            this.detailsForm.get(this.leaseTypeFormControlName).disable();
            this.detailsForm.get(this.leaseReasonFormControlName).setValue(application.leaseReason);
            this.detailsForm.get(this.leaseReasonFormControlName).disable();
            this.detailsForm.get(this.leaseUseFormControlName).setValue(application.leaseUse);
            this.detailsForm.get(this.leaseRentalAgreementFormControlName).setValue(application.leaseRentalAgreementAmount);
            this.detailsForm.get(this.leaseStartDateFormControlName).setValue(this.datePipe.transform(application.leaseEndDate, "yyyy-MM-dd"));
            this.detailsForm.get(this.leaseEndDateFormControlName).setValue(this.datePipe.transform(application.leaseEndDate, "yyyy-MM-dd"));
            this.detailsForm.get(this.leaseUseFormControlName).disable();
            this.detailsForm.get(this.leaseRentalAgreementFormControlName).disable();
            this.detailsForm.get(this.leaseStartDateFormControlName).disable();
            this.detailsForm.get(this.leaseEndDateFormControlName).disable();
            this.detailsForm.get(this.leaseContractNumberFormControlName).setValue(application.leaseContractNumber);
            this.detailsForm.get(this.leaseAccountNumberFormControlName).setValue(application.leaseAccountNumber);
            this.detailsForm.get(this.leaseContractEscalationFormControlName).setValue(application.leaseContractEscalation);
            this.detailsForm.get(this.leasePeriodFormControlName).setValue(application.leasePeriod);
            this.detailsForm.get(this.leaseNoticePeriodFormControlName).setValue(application.leaseNoticePeriod);
            this.detailsForm.get(this.leaseContractNumberFormControlName).disable();
            this.detailsForm.get(this.leaseAccountNumberFormControlName).disable();
            this.detailsForm.get(this.leaseContractEscalationFormControlName).disable();
            this.detailsForm.get(this.leasePeriodFormControlName).disable();
            this.detailsForm.get(this.leaseNoticePeriodFormControlName).disable();
            this.lesseeTypes.forEach(item => {
                if (item.value === application.leaseLesseeType) {
                    this.detailsForm.get(this.lesseeTypeFormControlName).setValue(item);
                }
            });
            this.detailsForm.get(this.lesseeTypeFormControlName).disable();
            this.leaseAreaDrawn = application.leaseAreas.length > 0 ? true : false;
            this.getLessees(application.jobId);
        }
        if (this.applicationType === "Acquisition") {
            this.detailsForm.get(this.saleAmountFormControlName).setValue(application.saleAmount);
            this.detailsForm.get(this.saleAmountFormControlName).disable();
            this.detailsForm.get(this.evaluationAmountFormControlName).setValue(application.evaluationAmount);
            this.detailsForm.get(this.evaluationAmountFormControlName).disable();
            this.detailsForm.get(this.dateofDeedTransferFormControlName).setValue(this.saShortDatePipe.transform(application.dateOfDeedTransfer, "yyyy-MM-dd"));
            this.detailsForm.get(this.dateofDeedTransferFormControlName).disable();
            this.getSellers(application.jobId);
        }
    }
    getLessees(jobId) {
        this.getLesseesObservableSubscription = this.propertyAndLeaseService
            .getLesseesObservable(jobId)
            .subscribe({
            next: (response) => this.onGetLesseesCompleted(response), error: (error) => {
                this.appControllerService.handleServerErrorMessage(ViewApplicationDetailsPlamsConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLesseesCompleted(response) {
        if (response && response.value.length > 0) {
            const lesseeControl = this.detailsForm.get(this.lesseeFormControlName);
            RecipientUtils.setRecipients(response.value, true, lesseeControl);
            this.changeDetectorRef.detectChanges();
        }
    }
    getSellers(jobId) {
        this.getSellersObservableSubscription = this.propertyAndLeaseService
            .getSellersObservable(jobId)
            .subscribe({
            next: (response) => this.onGetSellersCompleted(response), error: (error) => {
                this.appControllerService.handleServerErrorMessage(ViewApplicationDetailsPlamsConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetSellersCompleted(response) {
        if (response && response.value.length > 0) {
            const sellerControl = this.detailsForm.get(this.sellerFormControlName);
            RecipientUtils.setRecipients(response.value, true, sellerControl);
            this.changeDetectorRef.detectChanges();
        }
    }
    getBuyers(jobId) {
        this.propertyAndLeaseServiceSubscription = this.propertyAndLeaseService
            .getBuyersObservable(jobId)
            .subscribe({
            next: (response) => this.onGetBuyersCompleted(response), error: (error) => {
                this.appControllerService.handleServerErrorMessage(ViewApplicationDetailsPlamsConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetBuyersCompleted(response) {
        if (response && response.value.length > 0) {
            const buyerControl = this.detailsForm.get(this.buyerFormControlName);
            RecipientUtils.setRecipients(response.value, true, buyerControl);
            this.changeDetectorRef.detectChanges();
        }
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: DatePipe },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: PropertyAndLeaseService },
        { type: DatePipe },
        { type: RouterParamsService }
    ];
};
ViewApplicationDetailsPlamsComponent = __decorate([
    Component({
        selector: "app-view-application-details-plams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationDetailsPlamsComponent);
export { ViewApplicationDetailsPlamsComponent };
